import React from 'react';
import { Tooltip } from "@progress/kendo-react-tooltip";

const ReportTooltip = ({description}) => {

    return (
    <div  className='report-chart-tooltip'>
      <Tooltip openDelay={100} position="right" anchorElement="target">
        <img 
            title = {description}
            src="/icons/info.svg"
            alt="info"
            width="15"
            height="15"
        />      
      </Tooltip>
    </div>
    );
};

export default ReportTooltip;